// CommunitySubTabs.tsx — Posts/About/Members/Media/Events/Rules detail sub-tabs.
import { Tabs } from '@/ui';
import { SUB_TABS, type SubTab } from './meta';

export interface CommunitySubTabsProps {
  active: SubTab;
  onChange: (id: SubTab) => void;
}

export function CommunitySubTabs({ active, onChange }: CommunitySubTabsProps) {
  return (
    <Tabs
      items={SUB_TABS.map((t) => ({ value: t.id, label: t.label }))}
      value={active}
      onChange={(v) => onChange(v as SubTab)}
    />
  );
}
